import {
    VERIFY_USER,
    AUTH_LOGIN,
    FORGOT_PASSWORD,
    CHANGE_PASSWORD,
    AUTH_LOGOUT,
    AUTH_LOGIN_OTP,
    AUTH_RESEND_LOGIN_OTP,
    VERIFY_SETTING_PASSWORD,
    ADD_PASSWORD_USER,
    VERIFY_EMAIL_LOGIN
} from '@/api/modules/auth.api';

export default {
    login({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        AUTH_LOGIN({ payload }, successCallback, errorCallback);
    },

    resendOtp({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        AUTH_RESEND_LOGIN_OTP({ payload }, successCallback, errorCallback);
    },

    loginOtp({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        AUTH_LOGIN_OTP({ payload }, successCallback, errorCallback);
    },

    logOut({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        AUTH_LOGOUT({ payload }, successCallback, errorCallback);
    },

    forgotPassword({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        FORGOT_PASSWORD({ payload }, successCallback, errorCallback);
    },

    changePassword({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CHANGE_PASSWORD({ payload }, successCallback, errorCallback);
    },

    verify({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        VERIFY_USER({ payload }, successCallback, errorCallback);
    },

    verifySettingPassword({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        VERIFY_SETTING_PASSWORD({ payload }, successCallback, errorCallback);
    },

    verifyEmailLogin({ commit, state }, payload) {
        return VERIFY_EMAIL_LOGIN({ payload }, payload.successCallback, payload.errorCallback);
    },

    addPasswordUser({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        ADD_PASSWORD_USER({ payload }, successCallback, errorCallback);
    }
};
